<template>
  <div class="new-user-popup-container">
    <van-popup v-model="popup" get-container="#app" round>
      <div class="new-user-popup">
        <div class="van-popup close-icon" @click="close"></div>
        <van-image src="https://act.mcake.com/fangli/2019/new-PC/new/images/new-people/2022/new-people.png" fit="cover"/>
        <div class="new-user-popup-btn">
          <van-button type="primary" class="vanButton" @click="jump"></van-button>
        </div>
      </div>
    </van-popup>
   <!-- <van-count-down :time="time" @finish="finish" v-show="show"/>-->
  </div>
</template>
<script>
  export default {
    name: 'new-user-popup',
    data () {
      return {
        popup: !window.store.get('user_auth') && window.store.get('city_id') ? true : false,
        show: false,
        startTime: '2020-01-09 09:00:00',
        time: 0,
        cityIdShow: window.store.get('city_id') || 110
      }
    },
    methods: {
      jump () {
        window.location.href = '/#/active?id=2236&type=2'
      },
      close () {
        this.popup = false
      }
    }
  }
</script>
<style scoped>
  .van-popup {
    background: none; overflow-y:visible;
  }

  .new-user-popup {
    width: 9rem;
    margin: 0 auto;
    position: relative;
    text-align: center;
  }

  .new-user-popup-btn {
    position: absolute;
    bottom: 0.4rem;
    text-align: center;
    width: 100%;
  }

  .van-image{display: block;}
  .vanButton{ width: 3.3rem; border: none; background: url('https://act.mcake.com/fangli/2019/new-PC/new/images/new-people/2022/get-lq.png') no-repeat; background-size: 100%;}
  .van-popup.close-icon{width: 0.6rem; height: 0.6rem; position: absolute; top: -0.1rem; right: -0.4rem; background: url('https://act.mcake.com/fangli/2019/new-PC/new/images/close4.png') no-repeat; background-size: 100%; z-index:5;}

</style>



// WEBPACK FOOTER //
// src/components/home/new-user-popup.vue